import React from 'react';

import {
    IonApp,
    IonRouterOutlet, IonTitle,
    setupIonicReact
} from '@ionic/react';
import {IonReactRouter} from '@ionic/react-router';
import Dashboard from './pages/Dashboard';
import Auctions from './pages/Auctions';
import Profile from './pages/Profile';
import AuctionsAdmin from './pages/AdminList';

import Auctionsbid from './pages/Auctionsbid';
import Auctionsbook from './pages/Auctionsbook';
import Auctionedit from './pages/Auctionedit';

//AWS Cognito

import {type AuthUser} from "aws-amplify/auth";
import {type UseAuthenticator} from "@aws-amplify/ui-react-core";
import {Authenticator, Heading, useTheme, View, WithAuthenticatorProps} from '@aws-amplify/ui-react';
import {withAuthenticator} from '@aws-amplify/ui-react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

/* Theme variables */
import './theme/variables.css';
import './theme/app.css';
import {inspect} from "util";

import {Button} from "primereact/button";
import '@aws-amplify/ui-react/styles.css';

import "./app.css"


import {Redirect, Route} from 'react-router-dom';

type AppProps = {
    signOut?: UseAuthenticator["signOut"]; //() => void;
    user?: AuthUser;
};


setupIonicReact({
    mode: 'md'
});

export const App: React.FC<AppProps> = () => {
    const components = {
        Header() {
            const {tokens} = useTheme();
            return <View textAlign="center" padding={tokens.space.large}>
                <div className={"flex flex-col text-center items-center"}><img className={"h-40 text-center"}
                                                                               src="assets/images/MADfreight-logo.png"
                                                                               alt="logo"/></div>

            </View>
        },
        Footer() {
            return <View textAlign="center">For Login help contact: <a className={"text-blue-600"}
                                                                       href={"mailto:help@madwood.com"}>help@madwood.com</a></View>
        }
    }
    return (
        <>
            <Authenticator components={components}>
                {({signOut, user}) => (
                    <IonApp>
                        <IonReactRouter>
                            <IonRouterOutlet>
                                <Route exact path="/admin-auctions" sensitive={true}>
                                    <AuctionsAdmin user={user || {} as AuthUser} signOut={signOut}/>
                                </Route>
                                <Route exact path="/dashboard" sensitive={true}>
                                    <Dashboard user={user || {} as AuthUser}/>
                                </Route>
                                <Route exact path="/auctions" sensitive={true}>
                                    <Auctions user={user || {} as AuthUser}/>
                                </Route>
                                <Route path="/profile" sensitive={true}>
                                    <Profile user={user || {} as AuthUser}/>
                                </Route>
                                <Route path="/book-now/:orderID" component={Auctionsbook} sensitive={true}>
                                </Route>
                                <Route path="/bid/:orderID" component={Auctionsbid} sensitive={true}>
                                </Route>
                                <Route path="/admin-auction-edit/:orderID" component={Auctionedit} sensitive={true}>
                                </Route>
                                <Route exact path="/">
                                    <Redirect to="/auctions"/>
                                </Route>
                            </IonRouterOutlet>
                        </IonReactRouter>
                    </IonApp>
                )}

            </Authenticator>


        </>
    );
};
